// ActionButtons.js
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import {
  UserCircleIcon,
  TruckIcon,
  PencilSquareIcon,
  TrashIcon
} from '@heroicons/react/24/outline';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';

// Helper function for class names
function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const ActionsButton = ({
  customer,
  handleVehiclesButtonClick,
  openEditModal,
  deleteCustomer,
}) => {
  return (
    <div className="inline-flex rounded-lg shadow-sm">
      <Menu as="div" className="relative inline-block text-left">
        <div>
          <Menu.Button className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 transition-all duration-200 shadow-sm hover:shadow-md">
            Actions
            <ChevronDownIcon className="h-4 w-4 text-gray-500" aria-hidden="true" />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right rounded-xl bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none z-30 overflow-hidden border border-gray-200">
            <div className="py-1">
              {/* Profile Menu Item */}
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to={`/customers/profile/${customer.id}`}
                    className={classNames(
                      active ? 'bg-gradient-to-r from-blue-50 to-indigo-50 text-blue-700' : 'text-gray-700',
                      'group flex items-center gap-3 px-4 py-3 text-sm font-medium transition-all duration-150'
                    )}
                  >
                    <UserCircleIcon className={classNames(
                      active ? 'text-blue-600' : 'text-gray-400',
                      'h-5 w-5 transition-colors'
                    )} />
                    <span>View Profile</span>
                  </Link>
                )}
              </Menu.Item>

              {/* Vehicles Menu Item */}
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => handleVehiclesButtonClick(customer)}
                    className={classNames(
                      active ? 'bg-gradient-to-r from-green-50 to-emerald-50 text-green-700' : 'text-gray-700',
                      'group flex items-center gap-3 px-4 py-3 text-sm font-medium w-full transition-all duration-150'
                    )}
                  >
                    <TruckIcon className={classNames(
                      active ? 'text-green-600' : 'text-gray-400',
                      'h-5 w-5 transition-colors'
                    )} />
                    <span>View Vehicles</span>
                  </button>
                )}
              </Menu.Item>

              {/* Divider */}
              <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent my-1" />

              {/* Edit Menu Item */}
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => openEditModal(customer)}
                    className={classNames(
                      active ? 'bg-gradient-to-r from-amber-50 to-orange-50 text-amber-700' : 'text-gray-700',
                      'group flex items-center gap-3 px-4 py-3 text-sm font-medium w-full transition-all duration-150'
                    )}
                  >
                    <PencilSquareIcon className={classNames(
                      active ? 'text-amber-600' : 'text-gray-400',
                      'h-5 w-5 transition-colors'
                    )} />
                    <span>Edit Customer</span>
                  </button>
                )}
              </Menu.Item>

              {/* Delete Menu Item */}
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => deleteCustomer(customer.id)}
                    className={classNames(
                      active ? 'bg-gradient-to-r from-red-50 to-rose-50 text-red-700' : 'text-gray-700',
                      'group flex items-center gap-3 px-4 py-3 text-sm font-medium w-full transition-all duration-150'
                    )}
                  >
                    <TrashIcon className={classNames(
                      active ? 'text-red-600' : 'text-gray-400',
                      'h-5 w-5 transition-colors'
                    )} />
                    <span>Delete Customer</span>
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export default ActionsButton;
